var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox receipt-template-page" },
    [
      _c(
        "el-card",
        { staticClass: "box-card page-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "page-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "header-left" }, [
                _c("span", { staticClass: "page-title" }, [_vm._v("小票模板")]),
                _vm._v(" "),
                _c("span", { staticClass: "page-desc" }, [
                  _vm._v("管理外卖小票打印模板"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:merchant:ticket:template:save"],
                      expression: "['admin:merchant:ticket:template:save']",
                    },
                  ],
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.handleCreate },
                },
                [_vm._v("新建模板")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c("el-input", {
                staticClass: "search-input",
                attrs: {
                  placeholder: "搜索模板名称",
                  clearable: "",
                  size: "small",
                  "prefix-icon": "el-icon-search",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleSearch($event)
                  },
                },
                model: {
                  value: _vm.searchTerm,
                  callback: function ($$v) {
                    _vm.searchTerm = $$v
                  },
                  expression: "searchTerm",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "search-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("搜索")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.resetSearch },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "template-table",
              attrs: {
                data: _vm.templates,
                border: "",
                stripe: "",
                size: "small",
                "empty-text": "暂无模板数据",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "templateName",
                  label: "模板名称",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sceneTypeName",
                  label: "适用场景",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.sceneTypeName ||
                                _vm.formatSceneType(scope.row.sceneType)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "最后修改时间", "min-width": "170" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.formatTime(scope.row.updateTime))),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                Number(scope.row.status) === 1
                                  ? "success"
                                  : "info",
                              size: "mini",
                              effect: "plain",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  Number(scope.row.status) === 1
                                    ? "启用中"
                                    : "已停用"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "是否默认", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#13ce66",
                            "inactive-color": "#dcdfe6",
                            disabled: scope.row.canSwitchDefault === false,
                            "active-value": true,
                            "inactive-value": false,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleToggleDefault(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.isDefault,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "isDefault", $$v)
                            },
                            expression: "scope.row.isDefault",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "160",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:merchant:ticket:template:update",
                                ],
                                expression:
                                  "['admin:merchant:ticket:template:update']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:merchant:ticket:template:save"],
                                expression:
                                  "['admin:merchant:ticket:template:save']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCopy(scope.row)
                              },
                            },
                          },
                          [_vm._v("复制")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:merchant:ticket:template:delete",
                                ],
                                expression:
                                  "['admin:merchant:ticket:template:delete']",
                              },
                            ],
                            staticClass: "danger-btn",
                            attrs: {
                              type: "text",
                              size: "small",
                              disabled: scope.row.canDelete === false,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.page,
                  "page-size": _vm.pageSize,
                  total: _vm.total,
                  background: "",
                  small: "",
                  layout: "total, sizes, prev, pager, next",
                  "page-sizes": [10, 20, 50],
                },
                on: {
                  "update:currentPage": function ($event) {
                    _vm.page = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.page = $event
                  },
                  "update:pageSize": function ($event) {
                    _vm.pageSize = $event
                  },
                  "update:page-size": function ($event) {
                    _vm.pageSize = $event
                  },
                  "current-change": _vm.loadList,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }